export default "__VITE_ASSET__Di6n7u6Z__"